module.exports = __webpack_public_path__ + "img/caret-down-outline.3a4b82a5.svg";